import React from 'react';
import {Route, Switch} from "react-router-dom";
import {Helmet} from "react-helmet";
import {withBreadcrumb} from "../../Boilerplate/BreadcrumbContext";
import PunchListList from "./PunchListList";
import PunchListNew from "./PunchListNew";
import PunchList from "./PunchList";

const PunchLists = () => (
  <div>
    <Helmet>
      <title>Punch List</title>
    </Helmet>
    <Switch>
      <Route component={PunchListUi}/>
    </Switch>
  </div>
);

const PunchListUi = () => (
  <div>
    <Route exact path="/projects/:id/punch-list/" component={PunchListList}/>
    <Switch>
      <Route path="/projects/:id/punch-list/new" component={PunchListNew}/>
      <Route path="/projects/:id/punch-list/:punchListId" component={PunchList}/>
    </Switch>
  </div>
);

export default withBreadcrumb(
  ({ match }) => ({ title: 'Punch List', path: `/projects/${match.params.id}/punch-list/`}),
  PunchLists
);



// WEBPACK FOOTER //
// ./src/components/Projects/PunchList/PunchLists.js